import React, { useEffect, useRef } from 'react';
import './MessageModal.css';

const MessageModal = ({
  message,
  onConfirm,
  onCancel,
  onSpare,
  onClose,
  confirmText = "OK",
  cancelText = "Cancel",
  spareText = "Spare",
  autoClose = false,
  closeAfter = 3000,
  hideButtons = false,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.focus();
    }

    const focusableElements = document.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusableElements.forEach(el => {
      if (!el.closest('.modal-content')) {
        el.setAttribute('tabindex', '-1');
      }
    });

    let timer;
    if (autoClose) {
      timer = setTimeout(() => {
        if (onClose) onClose();
      }, closeAfter);
    }

    return () => {
      clearTimeout(timer);
      focusableElements.forEach(el => {
        if (!el.closest('.modal-content')) {
          el.removeAttribute('tabindex');
        }
      });
    };
  }, [autoClose, closeAfter, onClose]);

  return (
    <div className="modal-overlay">
      <div
        className="modal-content"
        ref={modalRef}
        tabIndex="-1"
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onConfirm) {
            onConfirm();
            if (onClose) onClose();
          }
          if (e.key === 'Escape' && onClose) {
            onClose();
          }
        }}
      >
        <p>{message}</p>
        {!hideButtons && (
          <div className="modal-buttons">
            {onSpare && (
              <button onClick={onSpare} className="btn-spare">{spareText}</button>
            )}
            {onConfirm && (
              <button onClick={onConfirm} className="btn-confirm">{confirmText}</button>
            )}
            {onCancel && (
              <button onClick={onCancel} className="btn-cancel">{cancelText}</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageModal;
